import { ErrorInfo, ReactNode } from 'react';
import * as React from 'react';

import PropTypes from 'prop-types';

import DefaultError from '../../route/ErrorFallback';

interface States {
  error: Error | null;
  info: ErrorInfo | null;
}

interface Props {
  children: ReactNode;
  Fallback?: React.FC<{ error: States['error']; info: States['info'] }>;
  customerServiceUrl: string;
}

export default class ErrorBoundary extends React.Component<Props, States> {
  // eslint-disable-next-line react/static-property-placement
  static propTypes = {
    children: PropTypes.node.isRequired,
    Fallback: PropTypes.node,
    customerServiceUrl: PropTypes.string.isRequired,
  };

  constructor(props: Props) {
    super(props);
    this.state = { error: null, info: null };
  }

  componentDidCatch(error: States['error'], info: States['info']) {
    this.setState({ error, info });
  }

  render() {
    const { error, info } = this.state;
    const { children, Fallback, customerServiceUrl } = this.props;
    if (error) {
      if (Fallback) {
        return <Fallback error={error} info={info} />;
      }
      return <DefaultError error={error} customerServiceUrl={customerServiceUrl} />;
    }

    return children;
  }
}
